import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils';
import type { VariantBarcodeMark } from './productDetailMeta';

type VariantBarcodeMarkChipProps = {
    mark: VariantBarcodeMark;
    variantId: string;
    /** Where the chip sits, so each place has its own test id. */
    placement: 'row' | 'card';
    /** Layout only, e.g. hiding it on narrow screens. */
    className?: string;
};

const MARK_COLOR = {
    generated: 'accent',
    kept: 'default',
} as const satisfies Record<VariantBarcodeMark, string>;

/**
 * The chip beside a variant's main barcode (bos-app#238): "Generated" or
 * "Kept as is". Nothing to edit; the barcodes drawer changes the barcode.
 */
export const VariantBarcodeMarkChip: React.FC<VariantBarcodeMarkChipProps> = ({
    mark,
    variantId,
    placement,
    className,
}) => {
    const { t } = useTranslation('pages');

    return (
        <Chip
            className={className}
            color={MARK_COLOR[mark]}
            size="sm"
            variant="soft"
            {...getNodeTestIdProp(
                `product-variant-barcode-mark-${placement}-${variantId}`,
            )}
        >
            <Chip.Label>{t(`products.detail.barcodes.${mark}`)}</Chip.Label>
        </Chip>
    );
};
